import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "features/baseQuery";

interface ArchiveType {
  value: string;
  label: string;
  columns: string[];
}

interface ArchivesResponse {
  data: any[];
  total: number;
  page: number;
  totalPages: number;
}

interface ArchivesQuery {
  type: string;
  annee_scolaire: string;
  classe?: string;
  search?: string;
  page?: number;
  limit?: number;
}

interface RestoreRequest {
  type: string;
  ids: string[];
}

export const archivesSlice = createApi({
  reducerPath: "archivesApi",
  baseQuery: baseQueryWithAuth("archives"),
  tagTypes: ["Archives"],
  endpoints: (builder) => ({
    fetchArchiveTypes: builder.query<ArchiveType[], void>({
      query: () => "/types",
    }),
    fetchArchives: builder.query<ArchivesResponse, ArchivesQuery>({
      query: (params) => {
        const searchParams = new URLSearchParams();
        searchParams.set("type", params.type);
        searchParams.set("annee_scolaire", params.annee_scolaire);
        if (params.classe) searchParams.set("classe", params.classe);
        if (params.search) searchParams.set("search", params.search);
        if (params.page) searchParams.set("page", String(params.page));
        if (params.limit) searchParams.set("limit", String(params.limit));
        return `?${searchParams.toString()}`;
      },
      providesTags: ["Archives"],
    }),
    restoreArchives: builder.mutation<{ message: string; modifiedCount: number }, RestoreRequest>({
      query: (body) => ({
        url: "/restore",
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["Archives"],
    }),
  }),
});

export const {
  useFetchArchiveTypesQuery,
  useFetchArchivesQuery,
  useRestoreArchivesMutation,
} = archivesSlice;
